import * as React from 'react';
import RFProfileSetup from '../../../RFProfileSetup/Pages/RFProfileSetup.tsx';
import { isComponentUpdate } from 'smart-react';

/**
 * Tailwind-only Desktop view (Kendo removed)
 * Renders the Profile Setup list directly to avoid wrapper-induced paddings/margins.
 */
const DesktopView = ({
  selected,
  handleSelect,
  detailsDataModified,
  state,
}) => {
  const [profile, setProfile] = React.useState(state.dataSet);

  React.useEffect(() => {
    setProfile(state.dataSet);
  }, [state]);

  return (
    <div className="p-0">
      <RFProfileSetup profile={profile} />
    </div>
  );
};

// Export the memoized component
export default React.memo(DesktopView, isComponentUpdate);
